import React, { FormEvent, KeyboardEvent, ChangeEvent } from 'react';
import { validatePassword, MINIMUM_PASSWORD_LENGTH } from 'utils/validates';
import './styles.scss';
import InputGeneral from 'components/common/FormControls/FormInputs';
import ButtonMedium from 'components/common/Buttons/ButtonMedium';

export interface IOwnProps {
  emailOrUsername: string;
  password: string;
  onFieldChange: (
    fieldName: string,
  ) => (event: ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  setError: (error: string) => void;
}

const LoginForm = (props: IOwnProps) => {
  const { password, emailOrUsername, onFieldChange, handleSubmit, setError } =
    props;

  const onKeyUpPassword = (event: KeyboardEvent<HTMLFormElement>) => {
    if (
      event.key === 'Enter' &&
      password &&
      password.length < MINIMUM_PASSWORD_LENGTH
    ) {
      setError('Password is less than 8 characters');
    }
  };

  const isValid = validatePassword(password);

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <InputGeneral
        autoFocus
        label="Email or username"
        name="emailOrUsername"
        testidProp={'input-login-email-or-username'}
        value={emailOrUsername}
        type="login"
        onChange={onFieldChange('emailOrUsername')}
      />
      <InputGeneral
        label="Password"
        name="password"
        testidProp={'input-login-password'}
        type="password"
        value={password}
        onKeyUp={onKeyUpPassword}
        onChange={onFieldChange('password')}
      />
      <ButtonMedium
        testidProp={'login-button'}
        buttonRole={'primary'}
        disabled={!isValid}
        buttonType="submit"
        width={'300px'}
        margin={'15px 0'}
      >
        Login
      </ButtonMedium>
    </form>
  );
};

export default LoginForm;
